import { Module } from 'vuex';
import { RootStoreState } from '@/store';

export interface UnifiedInsightsReportsStoreState {
  filterData: any;
  nsmMetaData: any;
  totalWcmOnDemandReports: number;
}

export default {
  namespaced: true,
  state: {
    filterData: {
      reportType: [],
      deliveryMethod: [],
      status: [],
      product:[],
    },
    nsmMetaData: {},
    totalWcmOnDemandReports: 0,
  },

  mutations: {
    saveToFilters(state, data) {
      state.filterData = { ...state.filterData, ...data };
    },
    setNsmMetaData(state, data) {
      state.nsmMetaData = { ...data };
    },
    setWcmOnDemandReportsCount(state, data) {
      state.totalWcmOnDemandReports = data || 0;
    },
  },
  actions: {},
  getters: {
  },
} as Module<UnifiedInsightsReportsStoreState, RootStoreState>;
